var TorsoNestedModel = require('backbone-torso/modules/NestedModel');

/**
 * Model of a Survey Item.
 *
 * @class SurveyItemModel
 * @constructor
 */
module.exports = TorsoNestedModel.extend({
  /**
   * Get the main text for this survey item in the correct language.
   *
   * @method getMainText
   * @param surveyLanguageModel a model of the language set by the survey
   * @param defaultLanguageModel the language model to use if the browser language model doesn't work.
   * @returns {String} the text to display for this survey item in either the browser language or default language.
   */
  getMainText: function(surveyLanguageModel, defaultLanguageModel) {
    var mainTextByLanguageId = this.get('mainTextByLanguageId') || {},
        surveyLanguageId = surveyLanguageModel && surveyLanguageModel.get('id'),
        defaultLanguageId = defaultLanguageModel && defaultLanguageModel.get('id');

    return mainTextByLanguageId[surveyLanguageId] || mainTextByLanguageId[defaultLanguageId] || '';
  }
});
